import React from "react";
import { useNavigate } from "react-router-dom";
import { CButton, CContainer } from "@coreui/react-pro";
import PublicContentPageShell from "../../components/public/PublicContentPageShell";
import "../../styles/public-experience.css";
import "../../styles/public-family-alignment.css";

const MnuQualy = () => {
  const navigate = useNavigate();

  const hero = (
    <section className="public-info-hero">
      <CContainer fluid className="public-core-container public-page-shell public-info-shell">
        <div className="public-info-hero__panel public-page-hero-panel">
          <div className="public-info-hero__copy">
            <span className="public-core-eyebrow public-page-overline">Qualifikationen</span>
            <h1 className="public-page-title">Qualifikationen verständlich und belastbar zeigen</h1>
            <p className="public-page-body public-info-hero__lead">
              Experts4Europe hilft dabei, Ausbildung, Erfahrung, Sprache und Unterlagen so
              aufzubereiten, dass Arbeitgeber in Europa sie schneller einordnen können.
            </p>
            <div className="public-legal-chip-row">
              <span>Berufserfahrung</span>
              <span>Ausbildung</span>
              <span>Sprache</span>
            </div>
          </div>
          <aside className="public-info-hero__meta">
            <div className="public-page-callout public-info-callout">
              <strong>Sichtbarkeit</strong>
              <span>Relevante Stationen, Nachweise und Signale bleiben geordnet statt verstreut.</span>
            </div>
            <div className="public-page-callout public-info-callout">
              <strong>Einordnung</strong>
              <span>Qualifikation wird nicht nur gesammelt, sondern für den nächsten sinnvollen Schritt lesbar gemacht.</span>
            </div>
          </aside>
        </div>
      </CContainer>
    </section>
  );

  return (
    <PublicContentPageShell pageClassName="public-info-page" hero={hero}>
      <section className="public-core-band public-core-band--light">
        <CContainer fluid className="public-core-container public-page-shell public-info-shell">
          <div className="public-info-stack">
            <article className="public-page-card public-info-card">
              <span className="public-core-eyebrow public-page-overline">Was sichtbar wird</span>
              <div className="public-info-list">
                <div className="public-page-value-card public-info-value-card">
                  <h2 className="public-page-subtitle">Berufserfahrung</h2>
                  <p className="public-page-body">Relevante Stationen und praktische Aufgaben bleiben klar strukturiert und nachvollziehbar.</p>
                </div>
                <div className="public-page-value-card public-info-value-card">
                  <h2 className="public-page-subtitle">Ausbildung und Abschlüsse</h2>
                  <p className="public-page-body">Lernwege und Qualifikationen werden so dargestellt, dass europäische Arbeitgeber sie schneller lesen können.</p>
                </div>
                <div className="public-page-value-card public-info-value-card">
                  <h2 className="public-page-subtitle">Sprache und Nachweise</h2>
                  <p className="public-page-body">Sprachstand, Referenzen und Unterlagen ergänzen das Profil dort, wo sie Vertrauen schaffen.</p>
                </div>
              </div>
            </article>

            <article className="public-page-card public-info-card">
              <span className="public-core-eyebrow public-page-overline">Warum das zählt</span>
              <div className="public-info-list public-info-list--compact">
                <div className="public-page-value-card public-info-value-card">
                  <h2 className="public-page-subtitle">Weniger Missverständnisse</h2>
                  <p className="public-page-body">Arbeitgeber erkennen schneller, was tatsächlich vorhanden ist und wo noch Vorbereitung nötig bleibt.</p>
                </div>
                <div className="public-page-value-card public-info-value-card">
                  <h2 className="public-page-subtitle">Mehr Sichtbarkeit</h2>
                  <p className="public-page-body">Vollständige und gut lesbare Profile werden leichter gefunden und ruhiger bewertet.</p>
                </div>
                <div className="public-page-value-card public-info-value-card">
                  <h2 className="public-page-subtitle">Bessere Anschlussfähigkeit</h2>
                  <p className="public-page-body">Klare Qualifikationsdarstellung stärkt Bewerbung, Matching und die Vorbereitung auf weitere Schritte.</p>
                </div>
              </div>
            </article>

            <div className="public-info-actions public-page-card">
              <div className="public-info-actions__copy">
                <span className="public-core-eyebrow public-page-overline">Weiterlesen</span>
                <h2 className="public-page-subtitle">Öffentliche Einstiege ohne Sonderwelt</h2>
              </div>
              <div className="public-info-actions__buttons">
                <CButton type="button" className="public-core-btn public-core-btn--primary" onClick={() => navigate("/leitbild")}>
                  Leitbild lesen
                </CButton>
                <CButton type="button" className="public-core-btn public-core-btn--subtle" onClick={() => navigate("/applicant/frontdoor?entry=abroad")}>
                  Quick Check starten
                </CButton>
              </div>
            </div>
          </div>
        </CContainer>
      </section>
    </PublicContentPageShell>
  );
};

export default MnuQualy;
